export const CUSTOM_FIELD_LABEL_PERMISSION_TYPES = ['label', 'edit', 'manage'];
export const DEFAULT_FOLDER_SETTING = {};
